import React from "react"
import SEO from "../../seo"
import BlockContent from "@sanity/block-content-to-react"
import "./videoProject.css"
import { ProjectText } from "../../styled-components/ProjectText"
import { serializers } from "../../../libs/serializer"
class VideoProject extends React.Component {
  render() {
    return (
      <>
        <SEO title={this.props.title} />
        {this.props.videos.map((video, i) => (
          <iframe
            key={i}
            title={this.props.title}
            src={video}
            width="960"
            height="540"
            frameBorder="0"
            allowFullScreen
            style={{ marginBottom: "5px" }}
          />
        ))}
        <ProjectText>
          <BlockContent blocks={this.props.description} serializers={serializers}/>
          <BlockContent blocks={this.props.text} serializers={serializers} />
        </ProjectText>
      </>
    )
  }
}

export default VideoProject
